"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _ErrorPageForm = _interopRequireDefault(require("../ErrorPageForm"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _usageTracker = _interopRequireDefault(require("../../lib/usageTracker"));

var _ErrorDetails = _interopRequireDefault(require("./ErrorDetails"));

var _Grader = require("../../selectors/Grader");

var _Paths = require("../../constants/Paths");

var _default = function _default() {
  var domain = (0, _reactRedux.useSelector)(_Grader.getDomain);
  (0, _react.useEffect)(function () {
    if (domain) {
      _usageTracker.default.logView('Error');
    }
  }, []);
  return domain ? _react.default.createElement("div", {
    className: "error-page"
  }, _react.default.createElement(_UIIllustration.default, {
    name: "errors/map",
    width: "150px"
  }), _react.default.createElement(_Logo.default, null), _react.default.createElement("div", {
    className: "title"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "meta.title"
  })), _react.default.createElement(_ErrorDetails.default, null), _react.default.createElement(_ErrorPageForm.default, null)) : _react.default.createElement(_reactRouterDom.Redirect, {
    to: _Paths.ROOT
  });
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/ErrorPage.js
// module id = 167
// module chunks = 0